export default [
  {
    identity: 'host_1',
    name: 'George Wilson',
    type: 'host',
    selected: false,
    sid: 1,
    background:
      'https://p194.p3.n0.cdn.getcloudapp.com/items/geu2eLn1/Image%202020-03-30%20at%2010.11.00%20AM.png',
  },
  {
    identity: 'guest_2',
    name: 'Jill Adams',
    type: 'guest',
    selected: false,
    sid: 2,
    background:
      'https://p194.p3.n0.cdn.getcloudapp.com/items/04uKZpw9/frank-busch-g7uPG8w1XV8-unsplash.jpg?v=2273c707c36fdb27801683454bbf363d',
  },
  {
    identity: 'guest_3',
    name: 'Kyle Jacobson',
    type: 'guest',
    selected: false,
    sid: 3,
    background:
      'https://p194.p3.n0.cdn.getcloudapp.com/items/WnuNnoyL/Image%202020-03-30%20at%2010.20.52%20AM.png?v=65c11a3bf84bb6f3c28a199ae47bb87b',
  },
  {
    identity: 'guest_4',
    name: 'Jason Fausto',
    type: 'guest',
    selected: false,
    sid: 4,
    background:
      'https://p194.p3.n0.cdn.getcloudapp.com/items/YEuAELEP/jackson-schaal-AR9mvykzSOA-unsplash.jpg?v=1cd85d23170057a707646b07638a6efb',
  },
  {
    identity: 'guest_5',
    name: 'Deborah Olson',
    type: 'guest',
    selected: false,
    sid: 5,
    background:
      'https://p194.p3.n0.cdn.getcloudapp.com/items/5zuyq0WX/Image%202020-03-30%20at%2010.30.03%20AM.png?v=f09b39d4a4581770dcb4a5c736a172fe',
  },
  {
    identity: 'guest_6',
    name: 'Sophia Munn',
    type: 'guest',
    selected: false,
    sid: 6,
    background:
      'https://p194.p3.n0.cdn.getcloudapp.com/items/JruWBK7B/Image%202020-03-30%20at%2010.33.01%20AM.png?v=a5e5d52e576e662f1fe563094b068811',
  },
  {
    identity: 'guest_7',
    name: 'Guest #7',
    type: 'guest',
    selected: false,
    sid: 7,
  },
  {
    identity: 'guest_8',
    name: 'Guest #8',
    type: 'guest',
    selected: false,
    sid: 8,
  },
  {
    identity: 'guest_9',
    name: 'Guest #9',
    type: 'guest',
    selected: false,
    sid: 9,
  },
  {
    identity: 'guest_10',
    name: 'Guest #10',
    type: 'guest',
    selected: false,
    sid: 10,
  },
  {
    identity: 'guest_11',
    name: 'Guest #11',
    type: 'guest',
    selected: false,
    sid: 11,
  },
  {
    identity: 'guest_12',
    name: 'Guest #12',
    type: 'guest',
    selected: false,
    sid: 12,
  },
  {
    identity: 'guest_13',
    name: 'Guest #13',
    type: 'guest',
    selected: false,
    sid: 13,
  },
  // {
  //   "identity": "guest_14",
  //   "name": "Guest #14",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 14
  // },
  // {
  //   "identity": "guest_15",
  //   "name": "Guest #15",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 15
  // },
  // {
  //   "identity": "guest_16",
  //   "name": "Guest #16",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 16
  // },
  // {
  //   "identity": "guest_17",
  //   "name": "Guest #17",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 17
  // },
  // {
  //   "identity": "host_18",
  //   "name": "Host #18",
  //   "type": "host",
  //   "selected": false,
  //   "sid": 18
  // },
  // {
  //   "identity": "guest_19",
  //   "name": "Guest #19",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 19
  // },
  // {
  //   "identity": "guest_20",
  //   "name": "Guest #20",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 20
  // },
  // {
  //   "identity": "guest_21",
  //   "name": "Guest #21",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 21
  // },
  // {
  //   "identity": "guest_22",
  //   "name": "Guest #22",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 22
  // },
  // {
  //   "identity": "guest_23",
  //   "name": "Guest #23",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 23
  // },
  // {
  //   "identity": "guest_24",
  //   "name": "Guest #24",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 24
  // },
  // {
  //   "identity": "guest_25",
  //   "name": "Guest #25",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 25
  // },
  // {
  //   "identity": "guest_26",
  //   "name": "Guest #26",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 26
  // },
  // {
  //   "identity": "guest_27",
  //   "name": "Guest #27",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 27
  // },
  // {
  //   "identity": "guest_28",
  //   "name": "Guest #28",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 28
  // },
  // {
  //   "identity": "guest_29",
  //   "name": "Guest #29",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 29
  // },
  // {
  //   "identity": "guest_30",
  //   "name": "Guest #30",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 30
  // },
  // {
  //   "identity": "guest_31",
  //   "name": "Guest #31",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 31
  // },
  // {
  //   "identity": "guest_32",
  //   "name": "Guest #32",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 32
  // },
  // {
  //   "identity": "guest_33",
  //   "name": "Guest #33",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 33
  // },
  // {
  //   "identity": "guest_34",
  //   "name": "Guest #34",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 34
  // },
  // {
  //   "identity": "guest_35",
  //   "name": "Guest #35",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 35
  // },
  // {
  //   "identity": "guest_36",
  //   "name": "Guest #36",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 36
  // },
  // {
  //   "identity": "guest_37",
  //   "name": "Guest #37",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 37
  // },
  // {
  //   "identity": "guest_38",
  //   "name": "Guest #38",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 38
  // },
  // {
  //   "identity": "guest_39",
  //   "name": "Guest #39",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 39
  // },
  // {
  //   "identity": "guest_40",
  //   "name": "Guest #40",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 40
  // },
  // {
  //   "identity": "guest_41",
  //   "name": "Guest #41",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 41
  // },
  // {
  //   "identity": "guest_42",
  //   "name": "Guest #42",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 42
  // },
  // {
  //   "identity": "guest_43",
  //   "name": "Guest #43",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 43
  // },
  // {
  //   "identity": "guest_44",
  //   "name": "Guest #44",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 44
  // },
  // {
  //   "identity": "guest_45",
  //   "name": "Guest #45",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 45
  // },
  // {
  //   "identity": "guest_46",
  //   "name": "Guest #46",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 46
  // },
  // {
  //   "identity": "guest_47",
  //   "name": "Guest #47",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 47
  // },
  // {
  //   "identity": "guest_48",
  //   "name": "Guest #48",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 48
  // },
  // {
  //   "identity": "guest_49",
  //   "name": "Guest #49",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 49
  // },
  // {
  //   "identity": "guest_50",
  //   "name": "Guest #50",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 50
  // },
  // {
  //   "identity": "guest_51",
  //   "name": "Guest #51",
  //   "type": "guest",
  //   "selected": false,
  //   "sid": 51
  // }
];
